import { useLanguage } from "@/context/LanguageContext";
import { useSmoothScroll } from "@/context/SmoothScrollContext";
import { contact, content } from "@/i18n/content";
import { LangSwitch } from "@/components/Header";
import WhatsAppIcon from "@/components/icons/WhatsAppIcon";

const Footer = () => {
  const { pick } = useLanguage();
  const { scrollTo } = useSmoothScroll();

  const sitemap = [
    { key: "about", href: "#about" },
    { key: "priorities", href: "#priorities" },
    { key: "gallery", href: "#gallery" },
    { key: "news", href: "#news" },
    { key: "contact", href: "#contact" },
  ];

  return (
    <footer data-testid="site-footer" className="bg-[#171717] text-[#F7F5F0]/60 border-t border-[#F7F5F0]/10">
      <div className="mx-auto max-w-[1600px] px-6 md:px-12 lg:px-24 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center bg-[#C42021] font-display text-sm font-bold text-[#F7F5F0]">
                SS
              </span>
              <span className="font-display text-lg font-bold text-[#F7F5F0]">
                {pick({ en: "Sanjay Sharma", hi: "संजय शर्मा" })}
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed">{pick(content.footer.tagline)}</p>
          </div>

          <nav aria-label="Footer">
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F7F5F0]/40">
              {pick(content.footer.sitemapTitle)}
            </h3>
            <ul className="mt-5 space-y-3">
              {sitemap.map((l) => (
                <li key={l.key}>
                  <button
                    type="button"
                    data-testid={`footer-${l.key}-link`}
                    onClick={() => scrollTo(l.href)}
                    className="text-sm transition-colors duration-300 hover:text-[#F7F5F0]"
                  >
                    {pick(content.nav[l.key])}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F7F5F0]/40">
              {pick(content.footer.connectTitle)}
            </h3>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a data-testid="footer-phone-link" href={contact.phoneHref} className="transition-colors hover:text-[#F7F5F0]">
                  {contact.phoneDisplay}
                </a>
              </li>
              <li>
                <a data-testid="footer-email-link" href={`mailto:${contact.email}`} className="transition-colors hover:text-[#F7F5F0]">
                  {contact.email}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-whatsapp-link"
                  href={contact.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 transition-colors hover:text-[#F7F5F0]"
                >
                  <WhatsAppIcon size={16} aria-hidden="true" />
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[11px] font-semibold uppercase tracking-[0.24em] text-[#F7F5F0]/40">
              {pick(content.footer.metaTitle)}
            </h3>
            <div className="mt-5 flex flex-col items-start gap-5">
              <div>
                <p className="mb-2 text-xs">{pick(content.footer.language)}</p>
                <LangSwitch dark compact />
              </div>
              <p className="text-xs">{pick(content.footer.compliance)}</p>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col md:flex-row md:items-center md:justify-between gap-3 border-t border-[#F7F5F0]/10 pt-8 text-xs">
          <p>{pick(content.footer.rights)}</p>
          <p className="text-[#F7F5F0]/40">{pick(content.footer.approval)}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
